module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/banco_general_panama.47196839.svg";